// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quotas-info__header[data-v-718cc2ad]{background-color:#fff;padding:26px 38px}.quotas-info__header-logo[data-v-718cc2ad]{display:flex;justify-content:space-between;align-items:center}.quotas-info__header-logo-img[data-v-718cc2ad]{max-width:600px}.quotas-info__header-content[data-v-718cc2ad]{font-size:20px;font-style:normal;font-weight:700;line-height:24px;padding-top:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
